import React from 'react'
import './Contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {AiOutlineInstagram} from 'react-icons/ai'
import {AiOutlineWhatsApp} from 'react-icons/ai'
import  { useRef } from 'react';
import emailjs from 'emailjs-com';
const Contact = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_kkw1rhc', 'template_lzmj27u', form.current, 'LEB16c9BhejheiRKh')
        e.target.reset()
    };
    return (
        <section id="contact">
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>
            <div className="container contact_container">
                <div className="contact_options">
                    <article className="contact_option">
                        <MdOutlineEmail className="contact_icon"/>
                        <h4>Email</h4>
                        <h5>DanialMeds@gmail.com</h5>
                        <a href="mailto:vaibhavmeshram910@gmail.com">Send a Message</a>
                    </article>                    
                    <article className="contact_option">
                        <AiOutlineInstagram className="contact_icon"/>
                        <h4>Instagram</h4>
                        <h5>Chat On Insatgram</h5>
                        <a href="https://www.instagram.com/direct/t/sudip_urkude09">Send a Message</a>
                    </article>                    
                    <article className="contact_option">
                        <AiOutlineWhatsApp className="contact_icon"/>
                        <h4>Whatsapp</h4>
                        <h5>Chat On Whatsapp</h5>
                        <a href="https://api.whatsapp.com/send?phone=+918879450932" >Send a Message</a>
                    </article>                    
                </div>
                <form ref={form} onSubmit={sendEmail}>
                    <input type="text" name="name" placeholder='Your Name' required/>
                    <input type="email" name="email" placeholder='Your Mail-id' required/>
                    <textarea name="message" placeholder="Share Your'e Message"rows="10" required/>
                    <button type="submit" className='btn btn-primary'>Send</button>
                </form>
            </div>
        </section>
    )
}

export default Contact
